<template>
  <iframe :src="url" frameborder="0" v-if="url"></iframe>
</template>

<script>
export default {
  data() {
    return {
      url:"",
    };
  },
  created() {
    this.getLink();
  },
  methods: {
    getLink() {
      this.$http({
        url: "/master/group/checkTenant",
        type: "GET",
        params: {}
      }).then((res) => {
        if(res.data) {
          this.url = '/master/group/settlement';
        }else{
          this.$alert('暂无权限，请联系您的销售支持', '信息', {
            confirmButtonText: '确定',
            callback: action => {}
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
iframe {
  width: 100%;
  height: 100vh;
  display: block;
}
</style>